<template>
    <div>
        <v-card class="rounded-0" flat>
            <ValidationObserver ref="obs" v-slot="{ invalid }">
                <v-form name="FormPreContactos" @submit.prevent="guardar" autocomplete="off">
                    <v-card-title class="mb-5 font-weight-bold text-body-1 black--text text-uppercase">
                        <v-icon class="mr-2" color="red">
                            mdi-map-marker-outline
                        </v-icon>
                        Domicilio
                    </v-card-title>
                    <v-card-text class="my-2">
                        <v-row>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-autocomplete dense :error-messages="v.errors[0]" autocomplete="off"
                                        v-model="datosContacto.domicilio.codprov" :items="provincias" ref="refProv"
                                        @input="cargarLocalidades" label="Provincia" return-object
                                        item-text="desprovincia" item-value="codigoProvincia"></v-autocomplete>
                                </ValidationProvider>
                            </v-col>
                            <v-col v-if="datosContacto.domicilio.codprov !== 1" cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-autocomplete dense :error-messages="v.errors[0]"
                                        v-model="datosContacto.domicilio.localidad" @input="cargarCodigoPostal"
                                        autocomplete="off" :items="localidades" item-text="nombre" item-value="nombre"
                                        return-object label="Localidad"></v-autocomplete>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col v-if="datosContacto.domicilio.codprov == 1" cols="12" md="6">
                                <ValidationProvider rules="required|alphanumeric_strict" v-slot="v">
                                    <v-autocomplete dense :error-messages="v.errors[0]"
                                        v-model="datosContacto.domicilio.calle" :items="localidades" item-value="calle"
                                        return-object autocomplete="off"
                                        :item-text="item => `${item.calle} - (${item.alturamax} - ${item.alturamin}) - C.P:${item.cp}`"
                                        label="Calle" @input="selectCalle"></v-autocomplete>
                                </ValidationProvider>
                            </v-col>
                            <v-col v-if="datosContacto.domicilio.codprov == 1" cols="12" md="6">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-text-field dense v-model="datosContacto.domicilio.nro" type="text" label="Nro."
                                        autocomplete="off" :error-messages="v.errors[0]"
                                        @keydown="preventArrowKeys"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row v-if="datosContacto.domicilio.codprov !== 1">
                            <v-col cols="6" md="6">
                                <ValidationProvider rules="required|alphanumeric_strict" v-slot="v">
                                    <v-text-field dense v-model="datosContacto.domicilio.calle"
                                        @keydown="preventArrowKeys" :error-messages="v.errors[0]" autocomplete="off"
                                        @input="datosContacto.domicilio.calle = datosContacto.domicilio.calle.toUpperCase()"
                                        type="text" label="Calle">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="6" md="6">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-text-field dense v-model="datosContacto.domicilio.nro" type="text" label="Nro."
                                        autocomplete="off" :error-messages="v.errors[0]"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="6" md="6">
                                <ValidationProvider v-slot="v">
                                    <v-text-field dense v-model="datosContacto.domicilio.piso" nro type="Piso"
                                        autocomplete="off" label="Piso."></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="6" md="6">
                                <ValidationProvider v-slot="v">
                                    <v-text-field dense v-model="datosContacto.domicilio.dep" autocomplete="off"
                                        @input="datosContacto.domicilio.dep = datosContacto.domicilio.dep.toUpperCase()"
                                        label="Dpto."></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                        <v-row>
                            <!--                             <v-col cols="12" md="4">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-autocomplete dense v-model="datosContacto.domicilio.tipcontacto"
                                        :items="tipoContacto" label="Tipo" item-value="tcnt_id"
                                        item-text="tcnt_des_tipcontacto" :error-messages="v.errors[0]"
                                        @input="selectTipoContDom" return-object></v-autocomplete>
                                </ValidationProvider>
                            </v-col> -->
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-text-field dense v-model="datosContacto.domicilio.cp" type="number"
                                        autocomplete="off" label="Código postal" :error-messages="v.errors[0]"
                                        @keydown="preventArrowKeys" hide-spin-buttons></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider class="my-5 mx-5"></v-divider>
                    <v-card-title class="mb-5 font-weight-bold text-body-1 black--text text-uppercase">
                        <v-icon class="mr-2" color="green">
                            mdi-phone-outline
                        </v-icon>
                        Teléfono
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols=" 12" md="3">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-autocomplete dense v-model.number="datosContacto.telefono.codpais"
                                        label="Cod. Pais" item-value="prefijo" :error-messages="v.errors[0]"
                                        autocomplete="off" :item-text="item => `(+${item.prefijo})  ${item.nombre}`"
                                        :items="codigoPais" @input="selectCodPais" return-object></v-autocomplete>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="5" md="3">
                                <ValidationProvider rules="required|minmax:2,4" v-slot="v">
                                    <v-text-field dense v-model="datosContacto.telefono.carac" prefix="0-"
                                        hide-spin-buttons type="number" @keydown="preventArrowKeys" autocomplete="off"
                                        label="Prefijo sin 0" :error-messages="v.errors[0]">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="7" md="3">
                                <!-- 
                                :rules="{ required: true, numeric: true, validPhone: { caracteristica: datosContacto.telefono.carac } }"
                                -->
                                <ValidationProvider :rules="getRules" v-slot="v">
                                    <v-text-field dense v-model="datosContacto.telefono.telefono" hide-spin-buttons
                                        type="number" autocomplete="off" @keydown="preventArrowKeys"
                                        :error-messages="v.errors[0]" label="Número"
                                        :prefix="(datosContacto.telefono.tiptelefono == 2) ? '15-' : ''">
                                    </v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="3">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-select dense v-model="datosContacto.telefono.tiptelefono" :items="itemTipTel"
                                        label="Tipo de Telefono" item-value="id" @input="selectTipoTelefono"
                                        autocomplete="off" return-object :error-messages="v.errors[0]"
                                        item-text="nombre">
                                    </v-select>
                                </ValidationProvider>
                            </v-col>
                            <!--                             <v-col cols="12" md="12" v-if="datosContacto.telefono.tiptelefono == 2">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-select dense v-model="datosContacto.telefono.idcarrier" :items="tipoCarrier"
                                        :error-messages="v.errors[0]" label="Empresa" item-value="id" autocomplete="off"
                                        item-text="descarrier" return-value="destipcarrier">
                                    </v-select>
                                </ValidationProvider>
                            </v-col> -->
                            <!-- <v-col cols="12" md="12">
                                <ValidationProvider rules="required" v-slot="v">
                                    <v-select dense v-model="datosContacto.telefono.tipcontacto" :items="tipoContacto"
                                        return-object @input="selectTipoContTel" item-text="tcnt_des_tipcontacto"
                                        :error-messages="v.errors[0]" item-value="tcnt_id" label="Tipo de contacto">
                                    </v-select>
                                </ValidationProvider>
                            </v-col> -->
                        </v-row>
                    </v-card-text>
                    <v-divider class="my-5 mx-5"></v-divider>
                    <v-card-title class="mb-5 font-weight-bold text-body-1 black--text text-uppercase">
                        <v-icon class="mr-2" color="indigo">
                            mdi-email-outline
                        </v-icon>
                        Correo electrónico
                    </v-card-title>
                    <v-card-text>
                        <v-row>
                            <v-col cols="12" md="12">
                                <ValidationProvider vid="confirmation" v-slot="v">
                                    <v-text-field dense v-model="datosContacto.email.email" @paste="handlePaste"
                                        autocomplete="off"
                                        @input="datosContacto.email.email = datosContacto.email.email.toLowerCase()"
                                        :error-messages="v.errors[0]" label="Correo electrónico"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                            <v-col cols="12" md="12">
                                <ValidationProvider rules="email|required|confirmed:confirmation" v-slot="v">
                                    <v-text-field dense v-model="confirmation" autocomplete="new-password"
                                        @paste="handlePaste" label="Confirmar correo electrónico"
                                        @input="confirmation = confirmation.toLowerCase()"
                                        :error-messages="v.errors[0]"></v-text-field>
                                </ValidationProvider>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-divider class="my-5"></v-divider>
                    <div class="d-flex justify-space-between form-footer" @click="forzarValidacion">
                        <v-btn color="secondary" outlined elevation="0" @click="volver" class="pa-5">
                            <v-icon class="mr-2">mdi-chevron-left</v-icon>atras
                        </v-btn>
                        <v-btn color="primary" elevation="0" type="submit" class="pa-5" :disabled="invalid">
                            <v-icon class="mr-2">mdi-chevron-right</v-icon>siguiente
                        </v-btn>
                    </div>
                </v-form>
            </ValidationObserver>
        </v-card>
    </div>
</template>


<script>
import { mapActions, mapGetters } from 'vuex'
import { ValidationProvider, ValidationObserver } from 'vee-validate';



export default {
    name: 'form-pre-contacto',
    components: {
        ValidationObserver,
        ValidationProvider,
    },
    computed: {
        ...mapGetters('common', ['tipoContacto', 'provincias', 'localidades', 'tipoCarrier', 'codigoPais']),
        getRules() {
            if (this.datosContacto.telefono.codpais == 54) return { required: true, numeric: true, validPhone: { caracteristica: this.datosContacto.telefono.carac } }
            else return { required: true, numeric: true }
        },
        camposCompletos() {
            return (this.datosContacto.telefono.carac !== '' && this.datosContacto.telefono.telefono !== '')
        }
    },
    data() {
        return {

            caracNumComplete: false,
            confirmation: '',

            itemTipTel: [
                { id: 2, nombre: 'CELULAR' },
                { id: 1, nombre: 'TELEFONO FIJO' },
            ],

            datosContacto:
            {
                //  domicilio
                domicilio: {
                    calle: '',
                    nro: '',
                    piso: '',
                    dep: '',
                    codprov: '',
                    recibecorreo: '',
                    localidad: '',
                    locid: 2084,
                    desprov: '',
                    tipcontacto: 1,
                    destipcontacto: '',
                    cp: '',
                },
                //  domicilio
                /* domicilio: {
                    calle: '66',
                    nro: '510',
                    piso: '3',
                    dep: 'C',
                    codprov: '',
                    recibecorreo: true,
                    localidad: 'La Plata',
                    locid: 2084,
                    desprov: '',
                    tipcontacto: 1,
                    destipcontacto: '',
                    cp: 1900,
                }, */

                //  Telefono
                telefono: {
                    idcarrier: 6,
                    idpais: 10,
                    codpais: 54,
                    carac: '',
                    telefono: '',
                    destipcarrier: '',
                    recibellamada: 1,
                    tiptelefono: '',
                    tipcontacto: 1,
                    destipcontacto: '',
                    destiptelefono: '',
                },
                /*                 telefonoComplete: {
                                    idcarrier: 6,
                                    idpais: 10,
                                    codpais: 54,
                                    carac: 221,
                                    telefono: 5433182,
                                    destipcarrier: '',
                                    recibellamada: 1,
                                    tiptelefono: 2,
                                    tipcontacto: 1,
                                    destipcontacto: '',
                                    destiptelefono: '',
                                }, */

                //  Email
                email: {
                    email: '',
                    recibeemail: 1,
                    tipcontacto: 1,
                    destipcontacto: '',
                },
            },
        }
    },
    watch: {
        // Observar cambios en codprov
        'datosContacto.domicilio.codprov'(newVal) {
            this.cargarLocalidades(newVal);
        },
    },
    mounted() {
        this.cargarLocalidades(2)
        this.$nextTick(() => {
            this.focusFirstInput();
        });
    },
    methods: {
        ...mapActions('notificaciones', ['showSnack']),
        ...mapActions('common', ['getCodigoPais', 'getNacionalidades', 'getTipoNacionalidad', 'getLocalidades']),
        ...mapActions('preafiliacion', ['guardarDatosContacto']),

        focusFirstInput() {
            // Busca el primer input, select o textarea visible dentro del formulario y le da foco
            this.$nextTick(() => {
                const form = this.$el.querySelector('form');
                if (form) {
                    const firstInput = form.querySelector('input:not([type=hidden]), select, textarea');
                    if (firstInput && typeof firstInput.focus === 'function') {
                        firstInput.focus();
                    }
                }
            });
        },

        forzarValidacion() {
            this.$refs.obs.validate().then(result => {
                if (!result) {
                    const firstErrorElement = this.$el.querySelector('.v-messages__message');
                    if (firstErrorElement) firstErrorElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
                }
            });
        },

        preventArrowKeys(event) {
            if (event.keyCode === 38 || event.keyCode === 40) {
                event.preventDefault();
            }
        },
        formatoYValidacion() {
            const car = this.datosContacto.telefono.carac.length
            const num = this.datosContacto.telefono.telefono.length

            if ((car + num !== 10) && (this.camposCompletos)) {
                this.showSnack({
                    message: 'La totalidad del número telefonico (prefijo y número) debe ser igual a 10 caractéres.',
                    type: '400'
                })
            }
        },
        handlePaste(e) {
            e.preventDefault();
            this.showSnack({
                message: 'No esta permitido copiar y pegar',
                type: '500'
            })
        },
        volver() {
            this.$emit('atras')
        },
        guardar() {
            this.$refs.obs.validate().then(result => {
                if (result) {
                    this.guardarDatosContacto(this.datosContacto)
                    this.$emit('siguiente')
                } else {
                    console.log('Formulario inválido, no se puede enviar la petición');
                }
            });
        },

        // Llama a focusFirstInput cuando el componente recibe el evento para volver a este paso
        activated() {
            this.focusFirstInput();
        },

        //** Metodos para domicilios */
        cargarLocalidades(value) {
            //cargo el nombre de la provincia en mayuscula
            this.datosContacto.domicilio.desprov = value.desprovincia.toUpperCase()

            //codigo provincia
            this.datosContacto.domicilio.codprov = value.codigoProvincia

            //cargo las localidades
            this.getLocalidades({ datoComun: 'obtenerLocalidades', codigoProvincia: value.codigoProvincia })

            //lo seteo como 
            this.datosContacto.domicilio.recibecorreo = 1
        },
        cargarCodigoPostal(value) {
            this.datosContacto.domicilio.localidad = value.nombre
            this.datosContacto.domicilio.locid = value.id
            this.datosContacto.domicilio.cp = value.cp
        },
        selectCalle(value) {
            this.datosContacto.domicilio.calle = value.calle
            this.datosContacto.domicilio.cp = value.cp
            this.datosContacto.domicilio.locid = value.id
            this.datosContacto.domicilio.localidad = value.nombre
        },
        selectTipoContDom(value) {
            console.log(value)
            this.datosContacto.domicilio.destipcontacto = value.tcnt_des_tipcontacto
            this.datosContacto.domicilio.tipcontacto = value.tcnt_id
        },

        //** Metodos para telefonos */
        selectCodPais(value) {
            this.datosContacto.telefono.idpais = value.id
            this.datosContacto.telefono.codpais = value.prefijo
            this.datosContacto.telefono.recibellamada = 1
        },
        selectTipoContTel(value) {
            this.datosContacto.telefono.destipcontacto = value.tcnt_des_tipcontacto
            this.datosContacto.telefono.tipcontacto = value.tcnt_id
        },
        selectTipoTelefono(value) {
            this.datosContacto.telefono.tiptelefono = value.id
            this.datosContacto.telefono.destiptelefono = value.nombre
            this.datosContacto.telefono.destipcarrier = ""
            this.datosContacto.telefono.idcarrier = 6
        },

        //** Metodos para mail */
        selectTipoContMail(value) {
            this.datosContacto.email.tipcontacto = value.tcnt_id
            this.datosContacto.email.destipcontacto = value.tcnt_des_tipcontacto
        },


    },


}
</script>

<style>
.form-content {
    padding-bottom: 110px;
    margin-bottom: 110px;
    /* Adjust as needed to avoid overlap with fixed footer */
}
</style>